import React from 'react';
import styles from './ServiceRequestPaymentDetail.module.scss';
import { formatCurrency } from '../formatCurrency';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetServiceRequestInstanceCustomerQuery } from '../../../../../../service/customersupport-service';
import { ApplicationRoutes } from '../../../../../../routes';

interface ServiceRequestPaymentContext {
    serviceRequestInstanceId: string;
    price: {
        currency: string;
        amount: number;
    };
}

interface ServiceRequestPaymentDetailProps {
    context: ServiceRequestPaymentContext;
}

const ServiceRequestPaymentDetail: React.FC<ServiceRequestPaymentDetailProps> = ({ context }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const numericId = parseInt(context.serviceRequestInstanceId, 10);
    const { data: instance, isLoading } = useGetServiceRequestInstanceCustomerQuery(
        numericId,
        { skip: isNaN(numericId) }
    );

    const handleMakePayment = () => {
        if (instance?.instanceId) {
            navigate(`/${ApplicationRoutes.CUSTOMER_SERVICE_REQUEST_PAYMENT}`, {
                state: {
                    serviceRequestInstanceId: instance.instanceId,
                    ticketNumber: instance.id,
                    amount: context.price?.amount ?? 0,
                    currency: context.price?.currency ?? 'N/A',
                    serviceTypeName: instance.serviceRequest?.name ?? '',
                },
            });
        } else if (context.serviceRequestInstanceId) {
            navigate(`/service-request/${context.serviceRequestInstanceId}`);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div className={styles.messageContainer}>
                <span className={styles.messageTitle}>
                    {t('serviceRequest.paymentRequired')}: {context.serviceRequestInstanceId}
                </span>
                <span className={styles.messageBody}>
                    {t('serviceRequest.srNotificationPaymentText', {
                        serviceRequestId: context.serviceRequestInstanceId,
                        amountToPay: formatCurrency(context.price?.amount ?? 0, context.price?.currency),
                    })}
                </span>
            </div>
            <button className={styles.btn} onClick={handleMakePayment} disabled={isLoading}>
                {isLoading ? t('buyElectricity.web.loadingText') : t('home.web.makePayment')}
            </button>
        </div>
    );
};

export default ServiceRequestPaymentDetail;
